module.exports = __webpack_public_path__ + "static/media/instagram.b492b607.svg";